<template>
  <div class="wrapper-bar-1">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 12)"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category">{{ item.sub_category.name }}</div>
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
            <i v-if="item.video" class="fas fa-play-circle icon-player"></i>
          </div>
          <div class="card__descr">
            <div class="card__title limited-text">{{ item.title }}</div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-1 {
  width: var(--width-media);
  margin: 0 auto;
  // padding: 2rem 0;
  @media screen and (max-width: 992px) {
    margin-top: 12rem;
    padding: 0 0 1.5rem 0;
  }
  @media screen and (max-width: 767px) {
    margin-top: 7.5rem;
    padding: 0;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
  }
}
.card {
  &__title {
    margin-top: 0.5rem;
    font-family: Roboto;
    font-weight: 400;
    font-size: calc(min(19px, 1vw));
    line-height: 1.25em;
    --snup: 4;
    @media screen and (max-width: 1100px) {
      font-size: calc(min(1.25em, 1.3vw));
    }
    @media screen and (max-width: 992px) {
      font-family: Roboto;
      font-style: normal;
      font-size: 1em;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-family: Roboto;
      font-size: 12px;
      line-height: 15px;
      color: var(--primary-font-color);
    }
  }
  .data-news {
    font-family: Open Sans;
    font-size: calc(min(0.9em, 0.85vw));
    line-height: 19px;
    margin-top: 8px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-size: 13px;
      line-height: 18px;
      color: var(--category-color);
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-size: 10px;
      line-height: 14px;

      // color: rgba(255, 255, 255, 0.6);
    }
  }
  &__img {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  &__category {
    position: absolute;
    z-index: 3;
    font-family: Open Sans;
    font-size: 14px;
    line-height: 19px;
    color: var(--category-color);
    background-color: var( --background-color);
    padding: 3px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}
.grid {
  display: grid;
  // padding: 0 1.5rem;
  grid-template-columns: repeat(21, 1fr);
  gap: 2rem;
  @media screen and (max-width: 992px) {
    // grid-template-columns: 1fr 1fr;
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }
  &__item {
    @media screen and (max-width: 992px) {
      flex: 0 1 50%;
      padding: 1rem;
      &:nth-child(2n) {
        transform: translateY(-120px);
      }
    }
    @media screen and (max-width: 767px) {
      padding: 0.5rem;
      &:nth-child(2n) {
        transform: translateY(-80px);
      }
    }
  }

  &__item:nth-child(1),
  &__item:nth-child(6) {
    grid-column: 1 / span 3;
    @media screen and (max-width: 992px) {
      grid-column: span 1;
    }
  }
  &__item:nth-child(2),
  &__item:nth-child(7) {
    grid-column: 4 / span 3;
  }
  &__item:nth-child(3),
  &__item:nth-child(8) {
    grid-column: 7 / span 3;
  }
  &__item:nth-child(4),
  &__item:nth-child(9) {
    grid-column: 10 / span 3;
  }
  &__item:nth-child(5) {
    grid-column: 13 / span 9;
    grid-row: span 2 /1;
    align-self: center;
  }
  &__item:nth-child(10),
  &__item:nth-child(11),
  &__item:nth-child(12) {
    grid-column: span 7;
  }
}
.card {
  width: 100%;
  &__img {
    position: relative;
    width: 100%;
    height: 6.5vw;
    @media screen and (max-width: 992px) {
      height: 200px !important;
    }
    @media screen and (max-width: 767px) {
      height: 106px !important;
    }
  }
  &__category {
    position: absolute;
    z-index: 1;
  }
}

.card-5 {
  .card__img {
    height: 20vw;
  }
}
.card-10,
.card-11,
.card-12 {
  .card__img {
    height: 16vw;
  }
}
.card-10 {
  padding-right: 1rem;
  @media screen and (max-width: 992px) {
    padding: 0;
  }
}
.card-11 {
  padding: 0 0.5rem;
  @media screen and (max-width: 992px) {
    padding: 0;
  }
}
.card-12 {
  padding-left: 1rem;
  @media screen and (max-width: 992px) {
    padding: 0;
  }
}
.icon-player {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1.2rem;
  color: #fff;
}
</style>
